export const project = {
  add: { label: "Ajouter un projet" },
  additionalCosts: {
    add: "Ajouter des coûts supplémentaires",
    addNewCost: "Ajouter un nouveau coût",
    type: "Type de coût",
    details: "Détails des coûts additionels",
    description: "Description",
    precision: "Précision",
    source: "Source",
    estimatedCost: "Montant",
    cumulatedAdditionalCosts: "Coûts additionnels cumulés",
  },
  batchEdit: {
    confirmation:
      "{{ count }} projets seront mis à jour avec la modification par lots. Vérifiez les options ci-dessous.",
    properties: {
      label: "Propriétés à mettre à jour",
      errors: {
        empty: "Veuillez saisir la propriété à mettre à jour.",
      },
    },
    userPlural: {
      label: "Utilisateurs",
    },
  },
  create: { label: "Créer un projet" },
  delete: {
    label: "Supprimer le projet",
  },
  associate: {
    confirmation: {
      associatedIntervention:
        "L’intervention `{{intervention}}` fait actuellement partie du projet `{{project}}`",
      more: "+ {{count}} interventions déjà liées à un autre projet",
      title:
        "Souhaitez vous vraiment déplacer les interventions suivantes dans le projet `{{project}}`",
    },
    success: {
      title: "Association effectuée avec succès!",
      description: "Une intervention a été associée",
      description_other: "{{count}} interventions ont été associées",
    },
    button: "Associer",
  },
  form: {
    associateWith: "Associer ce projet avec",
    description: {
      label: "Description",
    },
    dueDate: {
      label: "Date d'échéance",
    },
    edit: {
      label: "Modifier le projet",
    },
    informations: "Informations du projet",
    name: { label: "Nom" },
    location: {
      label: "Localisation",
    },
    progress: {
      label: "Progression",
    },
    reference: {
      label: "Référence",
    },
    startDate: {
      label: "Date de début",
    },
    status: {
      label: "Statut",
    },
    revisedInterventionsCost: {
      label: "Coût des interventions revisés",
    },
    documents: {
      label: "Fichiers joints",
    },
    users: {
      label: "Utilisateurs",
    },
  },
  list: {
    total: "Total",
    summaryTotalCost: "Coût total",
    interventionsTotalCost: "Coût total des interventions",
  },
  statistics: {
    costPerState: {
      title: "Coût total par état",
    },
    countPerState: {
      title: "Nombre de projets par état",
    },
    costPerYear: {
      title: "Coût majoré des projets par année",
    },
  },
  costsCard: {
    title: "Totaux",
    interventionsCost: "Coût des interventions",
    revisedInterventionsCost: "Coût des interventions revisés",
    additionalCosts: "Coûts additionnels",
    othersAdditionalCosts: "Autres coûts additionnels",
    addAdditionalCosts: "Ajouter des coûts additionnels",
    editAdditionalCosts: "Modifier les coûts additionnels",
    totalCost: "Coût total",
  },
};
